import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Grid } from "@mui/material";
import { v4 as uuid } from "uuid";
import { EditTemporaryDialog } from "@icoach/nonMember/dialog/";
import SendSmsDialog from "@icoach/components/dialog/SendSmsDialog";
import { NON_MEMBER_ROUTER } from "@icoach/router/routerPath";
import { Icons, Typography, Stack, IconButton, Chip, Button, Box } from "@curves/ui-base";
import { parseDate } from "@util/moment";
import { splitText } from "@icoach/nonMember/nonMember.util";

const FilterConditionBox = props => {
	const { texts = "" } = props;
	const regex = /(?=.*:)(?=.*&)/;
	const results = regex.test(texts) ? splitText(texts) : (texts?.split("、") ?? []);
	return (
		<Stack className="py-1" style={{ flex: 1, flexWrap: "wrap", rowGap: 6 }} key={uuid()} spacing={1} alignItems="center">
			{results.map(s => {
				return <Chip key={uuid()} label={s} color={"secondary"} />;
			})}
		</Stack>
	);
};

const TemporariesInfoHeader = props => {
	const [dialogOpen, setDialogOpen] = useState(null);
	const histtory = useHistory();
	const { sourceData = {} } = props;
	const { temporaryName, customerType, note = "", createdDate, temporaryID } = sourceData;

	const handleEditClick = e => {
		setDialogOpen("edit");
	};

	const handleSendTemporarySMS = () => {
		setDialogOpen("sendSMS");
	};

	const handleReturnOnClick = () => {
		histtory.push(NON_MEMBER_ROUTER.TEMPORARIES.OVERVIEW);
	};

	return (
		<Box className="p-4">
			<Grid container>
				<Grid item xs={8}>
					<Stack alignItems="center" spacing={2}>
						<IconButton onClick={handleEditClick}>
							<Icons.BorderColor />
						</IconButton>
						<Typography variant="span" className="h3">
							{temporaryName}
						</Typography>
					</Stack>
				</Grid>
				<Grid item xs={4}>
					<Stack justifyContent="end" spacing={1}>
						<Button variant="outlined" onClick={handleSendTemporarySMS}>
							發送簡訊
						</Button>
						<Button variant="contained" onClick={handleReturnOnClick}>
							返回暫存清單
						</Button>
					</Stack>
				</Grid>
			</Grid>
			<Stack className="pt-2" spacing="2">
				<Box style={{ display: "flex", gap: "10px", flexShrink: 0, flexWrap: "nowrap" }}>
					<Stack alignItems="center" spacing={1} style={{ flexShrink: 0 }}>
						<Icons.Clock />
						<Box>{parseDate(createdDate)}</Box>
					</Stack>
					<Stack alignItems="center" spacing={1} style={{ flexShrink: 0 }}>
						<Icons.File />
						<Box>{customerType}</Box>
					</Stack>
				</Box>
				<Stack alignItems="center" spacing={1}>
					<Icons.Magnifier />
					<FilterConditionBox texts={note} />
				</Stack>
			</Stack>
			<EditTemporaryDialog open={dialogOpen === "edit"} onClose={() => setDialogOpen(null)} fileName={temporaryName} />
			<SendSmsDialog open={dialogOpen === "sendSMS"} onClose={() => setDialogOpen(null)} affixParams={{ temporaryID }} isTemporaries />
		</Box>
	);
};

export default TemporariesInfoHeader;
